import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'

import { Layout, LayoutType } from '../components/layout'
import SEO from '../components/seo'

const NotFoundPage = (props) => {
  const { data } = props
  const siteTitle = data.site.siteMetadata.title

  return (
    <Layout location={props.location} title={siteTitle} type={LayoutType.Home}>
      <SEO 
        location={props.location}
        title="404: Not Found" 
      />
      <h1>We&apos;re sorry!</h1>
      <p>The page you are looking for does not exist.</p>
    </Layout>
  )
}

NotFoundPage.propTypes = {
  location: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
}

export default NotFoundPage

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
